import { render, staticRenderFns } from "./fwdw.vue?vue&type=template&id=5cefca54&scoped=true&"
import script from "./fwdw.vue?vue&type=script&lang=js&"
export * from "./fwdw.vue?vue&type=script&lang=js&"
import style0 from "./fwdw.vue?vue&type=style&index=0&id=5cefca54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cefca54",
  null
  
)

export default component.exports